import { FlexBox, Text } from '@trmediaab/zebra';

import { formatTeaserType } from './utils';

export default function Breadcrumb({ type, meta = [], color = 'greys.3' }) {
  return (
    <FlexBox pb="1" gap={{ _: 2, md: 3 }}>
      <Text
        textTransform="uppercase"
        color="brands.travrondenSpel"
        fontSize={{ _: 0, md: 1 }}
        fontWeight={{ _: 'bold', md: 'extraBold' }}
        flexShrink={0}
      >
        {formatTeaserType(type)}
      </Text>

      <Text
        fontSize={{ _: 0, md: 1 }}
        fontWeight={{ _: 'bold', md: 'extraBold' }}
        color={color}
        textTransform="uppercase"
        whiteSpace="pre-wrap"
      >
        {meta.join('  •  ')}
      </Text>
    </FlexBox>
  );
}
